import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import { findObjectById } from '@/components/Canvas/utils/groupHelpers';

export default {
  computed: {
    shapeStrokeWidth: {
      get() {
        const activeObject = this.activeObjectForLeftPanel;
        if (!activeObject) { return 0; }
        const isSvgStroke = activeObject.type == 'image'
            && activeObject.ImageType
            && (activeObject.ImageType == 'SVGImage'
                || activeObject.ImageType.indexOf('FDICText') !== -1
                || activeObject.ImageType.indexOf('FDICLogo') !== -1);
        if (isSvgStroke) {
          return (activeObject.SvgProperty && activeObject.SvgProperty.StrokeWidth) || 0;
        }
        return activeObject.StrokeWidth || 0;
      },
      set(value) {
        EventBus.$emit(ApplicationEventTypes.LeftPanelEvents.CHANGE_SHAPE_STROKE_WIDTH, value);
      },
    },
    shapeStrokeColor() {
      const defaultColor = '#000';
      const list         = this.getSelectedObjectsList;
      if (!list || !list.length || !list[0]) {
        return defaultColor;
      }

      const firstSelected = list[0];
      const aciveObject   = (this.contentList && findObjectById(this.contentList, firstSelected.Id)) || firstSelected;

      if (aciveObject.ImageType
          && (aciveObject.ImageType === 'SVGImage'
              || aciveObject.ImageType.indexOf('FDICText') !== -1
              || aciveObject.ImageType.indexOf('FDICLogo') !== -1)) {
        return aciveObject.SvgProperty && aciveObject.SvgProperty.StrokeColor
          ? aciveObject.SvgProperty.StrokeColor
          : defaultColor;
      }
      return aciveObject.StrokeColor || defaultColor;
    },
    getStrokeColorLabelShape() {
      if (!this.activeObjectForLeftPanel) { return '#fff'; }
      if (this.activeObjectForLeftPanel.type == 'image'
          && (this.activeObjectForLeftPanel.ImageType == 'SVGImage'
              || this.activeObjectForLeftPanel.ImageType.indexOf('FDICText') !== -1
              || this.activeObjectForLeftPanel.ImageType.indexOf('FDICLogo') !== -1)) {
        return this.activeObjectForLeftPanel.SvgProperty.StrokeColor;
      }
      return this.activeObjectForLeftPanel ? this.activeObjectForLeftPanel.StrokeColor : '#fff';
    },
    shapeOutlineRows() {
      const width = Number(this.shapeStrokeWidth) || 0;
      return [{
        key:     'thickness',
        label:   'Thickness',
        value:   this.shapeStrokeWidth,
        min:     0,
        max:     10,
        step:    1,
        fill:    Math.min(100, Math.max(0, width * 10)),
        display: width,
      }];
    },
    shapeEffectValue() {
      const effect = this.activeObjectForLeftPanel && this.activeObjectForLeftPanel.effect;
      return !effect || effect === 'none' ? 'none' : effect;
    },
  },
  methods: {
    onShapeOutlineColorChanged(payload) {
      if (!payload || payload.colorType !== 'outline') { return; }
      this.tempShapeOutlineColor = payload.rgba;
    },
    onShapeOutlineInput(payload) {
      this.shapeStrokeWidth = payload.value;
    },
  },
};
